import React from 'react'
import {useNavigate} from 'react-router-dom'

import {Stack} from '@mui/material'

import theme_ from 'theme/Theme'
import {AuthButton} from './AuthButton'
import * as AuthApi from 'api/auth'

import session_ from 'api/session'

import Env from 'env'

export default function AuthHeader() {
    const navigate = useNavigate()

    const [sessionUpdated, setSessionUpdated] = React.useState(false)

    const [openDrawer, setOpenDrawer] = React.useState(false)


    const th = theme_.homePageHeaderTheme

    React.useEffect(() => {
        // const sessionListener = () => {
        //     setSessionUpdated(!sessionUpdated);
        // }
        // session_.pubsub.addListener(session_.authListenerId, sessionListener);
        // return () => { session_.pubsub.removeListener(session_.authListenerId, sessionListener) };
    }, [])

    const onMenuItem = React.useCallback((key: string) => {
        setOpenDrawer(false)
    }, [])

    const onLogout = React.useCallback(() => {
        if (session_.isLoggedIn) {
            AuthApi.logout().then(() => {
                navigate('/')
            })
        } else {
            navigate('/login')
        }
    }, [])

    let greetingText = ''
    if (session_.greeting !== undefined && session_.greeting.length > 15) {
        greetingText = `${session_.greeting.substring(0, 15)}...`
    } else {
        greetingText = session_.greeting
    }

    if (Env.isMobile) {
        return (
            <>
                {!session_.isLoggedIn && (
                    <Stack direction='row' alignItems='center' justifyContent='center' spacing={1} sx={{mr: 2}}>
                        <AuthButton label={'Login'} href='/login' />
                    </Stack>
                )}
            </>
        )
    }

    return (
        <>
        <Stack direction='row' alignItems='center' justifyContent='center' spacing={1} sx={{mr: 2}}>
            {session_.isLoggedIn ? (
                <>
                    <AuthButton label={greetingText} href='/user'/>
                    <AuthButton label={'Logout'} onClick={onLogout} />
                </>
            ) : (
                <>
                    <AuthButton label={'Join'} href='/join' />
                    <AuthButton label={'Login'} href='/login' />
                </>
            )}
        </Stack>

        </>
    )
}
